import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType as NewEventType } from "@/features/events/types/EventType";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../../components/buttons/PrimaryButton";
import { MenuItem } from "../../../pages/new-platform/components/MenuItem";
import { SUPPORT_EMAIL, SUPPORT_PHONE_NUMBER } from "../../../utils/Constants";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import { useChatNotificationsStore } from "../../../utils/stores/useChatNotificationsStore";
import { useMenuStore } from "../../../utils/stores/useMenuStore";
import { useUserStore } from "../../../utils/stores/useUserStore";
import { useIsMetabolicUser } from "../../metabolic-health/hooks/useMetabolicHealth";
import CancelSubscriptionModal from "./CancelSubscriptionModal";

const Menu: React.FC<{
    onLogoutClick: () => void;}> = ({
    onLogoutClick,
}) => {
    const { isOpen, openMenu, closeMenu } = useMenuStore();
    const { auth } = useAuthStore()
    const userId = auth.userId
    const { userData } = useUserStore();
    const name = userData.name;
    const familyName = userData.familyName;
    const email = userData.email;
  
    const { unreadSessions } = useChatNotificationsStore();
    const isMetabolicUser = useIsMetabolicUser();
  
    const navigate = useNavigate();
    const { sendEvent } = useCreateEvent();

    const [isCancelSubscriptionModalOpen, setIsCancelSubscriptionModalOpen] = useState(false);

    // Analytics must never block or break the UI, so failures are swallowed here
    // (`sendEvent` rethrows on a failed request).
    const trackCancellationClick = (element: string) => {
      sendEvent({
        event: NewEventType.CLICK,
        sub_category: "cancellation",
        event_metadata: { element },
      }).catch(() => {});
    };

    return (
      <>
        <div
          className='hidden md:block cursor-pointer fixed top-0 left-0 w-full h-full bg-black opacity-30 z-[19] md:left-[100px]'
          onClick={closeMenu}
        />
        <div className='fixed top-0 left-0 w-full h-[calc(100%-90px)] bg-holifya-menu z-[20] flex flex-col items-center justify-center overflow-y-auto scrollbar-hide md:left-[100px] md:top-0 md:w-[393px] md:h-full'>
          <div className='w-[90%] h-full py-[20px] flex flex-col md:justify-between'>
            <div>
              <div className='w-full h-[35px] flex items-center justify-between'>
                <div className='leading-none'>
                  <img
                    src='/images/new-platform/logos/holifya-logo.svg'
                    alt='logo'
                  />
                </div>
                <div className='cursor-pointer' onClick={closeMenu}>
                  <img src='/images/new-platform/components/x.svg' alt='close' />
                </div>
              </div>
              <div className='mt-[20px] mb-[10px]'>
                <div className='font-bold text-[25px] leading-[33px]'>
                  {name} {familyName}
                </div>
              </div>
              <div className='mb-[20px]'>
                <div className='font-normal text-[14px] leading-[33px] no-underline text-inherit pointer-events-none cursor-default'>
                  <span>{email}</span>
                </div>
              </div>
              <div className='w-full md:w-[300px] h-[50px]'>
                <PrimaryButton
                  text='Acquista'
                  pointer={true}
                  disabled={false}
                  fontSize={18}
                  onClick={() => {
                    navigate('/purchase');
                    closeMenu();
                  }}
                />
              </div>
              <div className='my-[20px]'>
                <div className='font-bold text-[12px] leading-[20px] text-holifya-blue'>
                  Menu
                </div>
              </div>
              <MenuItem
                text={`${'\u{1F642}'} Dati personali`}
                onClick={() => {
                  navigate('/menu/personal-data');
                  closeMenu();
                }}
              />
              <MenuItem
                text={`${'\u{1F4B3}'} Acquisti e metodi di pagamento`}
                onClick={() => {
                  navigate('/menu/payment-methods-and-purchases');
                  closeMenu();
                }}
              />
              <div className='my-[20px]'>
                <div className='font-bold text-[12px] leading-[20px] text-holifya-blue'>
                  Parla con noi
                </div>
              </div>
              {/* <MenuItem
                  text={`${"\u{1F6E0}"} Come funziona`}
                  onClick={onHowItWorksClick}
                /> */}
              {/* {
                (isMetabolicUser || userId === "60532291-10fb-4652-aa11-a8cb247b6392") && <MenuItem
                  text={`💬 Chat`}
                  onClick={() => {
                    navigate('/chat');
                    closeMenu();
                  }}
                  showNotification={unreadSessions.length > 0}
                />
              } */}
              <MenuItem
                text={`📞  Chiamaci`}
                onClick={() => window.open(`tel:${SUPPORT_PHONE_NUMBER}`, '_self')}
              />
              <MenuItem
                text={`${'\u{1F4E7}'} Scrivici`}
                mailTo={SUPPORT_EMAIL}
              />
              <MenuItem
                text={`${'\u{1F64B}'} Domande frequenti`}
                onClick={() =>
                  window.open('https://www.holifya.com/pages/faqs', '_self')
                }
              />
              <div className='my-[20px]'>
                <div className='font-bold text-[12px] leading-[20px] text-holifya-blue'>
                  Note legali
                </div>
              </div>
              <MenuItem
                text={`⚖️ Termini e condizioni`}
                href='/assets/new-platform/personal-data-treatment.pdf'
              />
              <MenuItem
                text={`⚖️ Privacy policy`}
                href={process.env.REACT_APP_PRIVACY_POLICY_URL || '/assets/new-platform/v2.0_privacy_policy.pdf'}
              />
            </div>
            <div>
              <div className='w-full h-[1.5px] bg-black' />
              <MenuItem
                text={`🚫 Disdetta abbonamento`}
                onClick={() => {
                  trackCancellationClick('cancellation_cta');
                  setIsCancelSubscriptionModalOpen(true);
                }}
              />
              <div className='w-full h-[1.5px] bg-black' />
              <MenuItem text={`⬅️ Esci`} onClick={onLogoutClick} />
              <div className='h-[20px]' />
            </div>
          </div>
        </div>
        {isCancelSubscriptionModalOpen && (
          <CancelSubscriptionModal
            onClose={() => setIsCancelSubscriptionModalOpen(false)}
            onContactSupport={() => trackCancellationClick('cancellation_whatsapp')}
          />
        )}
      </>
    );
}

export default Menu
